module.exports = __webpack_public_path__ + "media/images/ride_requests/map_location-31c0ddc7360013f9f2fb7206d6d08a9f.svg";